import { Dispatch, SetStateAction, useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { ErrorResponse } from "../components/templates/Transaction";
import { SnackBarContext } from "../Context/SnackBarContext";

export const usePut = (
  endPoint: string,
  id: number,
  setResMsg: Dispatch<SetStateAction<string>>,
  setRender: Dispatch<SetStateAction<boolean>>,
  render: boolean,
  setIsSuccess: Dispatch<SetStateAction<boolean>>,
  handleClose: () => void
) => {
  const { showSnackBars, setShowSnackBars } = useContext(SnackBarContext);
  const { getAccessTokenSilently } = useAuth0();

  const unknownErrMsg =
    "意図しないエラーが発生しました。管理者に連絡してください。";

  const putRequest = async (body: BodyInit | null | undefined) => {
    try {
      const accessToken = await getAccessTokenSilently();
      const res = await fetch(
        `${process.env.REACT_APP_API_URL || ""}${endPoint}/${id}`,
        {
          method: "PUT",
          body,
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (res.ok) {
        setRender(!render);
        setIsSuccess(true);
        setResMsg("処理に成功しました。");
        setShowSnackBars(!showSnackBars);
        handleClose();
      } else if (res.status === 400) {
        // BEからエラーJSONが返された場合
        const errorJson = (await res.json()) as ErrorResponse;
        setIsSuccess(false);
        setResMsg(errorJson.message);
        setShowSnackBars(!showSnackBars);
      } else {
        // そもそもBEまで届いていない場合
        setIsSuccess(false);
        setResMsg(unknownErrMsg);
        setShowSnackBars(!showSnackBars);
      }
    } catch (e) {
      // その他、意図しないエラー
      setIsSuccess(false);
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      setResMsg(`${unknownErrMsg}${e}`);
      setShowSnackBars(!showSnackBars);
    }
  };

  return { putRequest };
};
